import { render, staticRenderFns } from "./skuSend.vue?vue&type=template&id=4f917bea&scoped=true"
import script from "./skuSend.vue?vue&type=script&lang=js"
export * from "./skuSend.vue?vue&type=script&lang=js"
import style0 from "./skuSend.vue?vue&type=style&index=0&id=4f917bea&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f917bea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f917bea')) {
      api.createRecord('4f917bea', component.options)
    } else {
      api.reload('4f917bea', component.options)
    }
    module.hot.accept("./skuSend.vue?vue&type=template&id=4f917bea&scoped=true", function () {
      api.rerender('4f917bea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderList/order/components/skuSend.vue"
export default component.exports